//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      visible: false,
      base: [{
        title: 'i18n.af0899b2737d45718ad65c983efb0b43',
        content: '2022.03.16 ~ 2022.04.15'
      }, {
        title: '398',
        content: '2022.04'
      }, {
        title: '28',
        content: '2022.03.28'
      }, {
        title: 'i18n.867a6368a19c419ab2997e50f49d1b78',
        content: '10,000.00 THB'
      }, {
        title: 'i18n.5dd5b55cdcf74ff2af6430496ec1e389',
        content: '1,000.00 THB'
      }]
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    }
  }
};